// extracted by mini-css-extract-plugin
export default {"NavItem":"NavItem_NavItem__tDLs-","active":"NavItem_active__lObvk"};